import { DnsRecord, EmailSendingDomain } from '@/models/emailSendingDomains';

const isMissingDomainDate = (value?: string) => {
  if (!value) {
    return true;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) || date.getTime() === 0;
};

export const formatDomainDate = (value?: string) => {
  if (isMissingDomainDate(value)) {
    return '—';
  }

  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(value!));
};

export const formatDomainDateTime = (value?: string) => {
  if (isMissingDomainDate(value)) {
    return '—';
  }

  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(value!));
};

export const formatLastChecked = (value: string | undefined, neverLabel: string) => {
  if (isMissingDomainDate(value)) {
    return neverLabel;
  }

  return formatDomainDateTime(value);
};

export const getDomainStatusBadgeClass = (status: EmailSendingDomain['status']) => {
  switch (status) {
    case 'VERIFIED':
      return 'bg-green-50 text-green-700';
    case 'VERIFYING':
      return 'bg-blue-50 text-blue-700';
    case 'FAILED':
      return 'bg-red-50 text-red-700';
    default:
      return 'bg-amber-50 text-amber-700';
  }
};

export const getRecordStatusBadgeClass = (status: DnsRecord['status']) => {
  switch (status) {
    case 'OK':
      return 'bg-green-50 text-green-700';
    case 'FAILED':
      return 'bg-red-50 text-red-700';
    default:
      return 'bg-amber-50 text-amber-700';
  }
};

export const countPassingRecords = (records: DnsRecord[]) => records.filter((record) => record.status === 'OK').length;
